import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldConfig } from '../field-interface';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TextEditorComponent } from '../../text-editor/text-editor.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  field: FieldConfig['eavAttribute'];
  group: UntypedFormGroup;
  visible: boolean;
  description: boolean;
  value: any;
  attributeCode: any;
  attributeId: any;
  constructor(
    public dialog: MatDialog
  , private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit() {
    this.visible = false;

  }




  // openEditorDescription(i) {
  //   if (window.innerWidth > 768) {
  //     const dialogRef = this.dialog.open(TextEditorComponent, {
  //       width: '900px',
  //       data: { field: this.field, group: this.group }
  //     });

  //     dialogRef.afterClosed().subscribe(result => {
  //       this.group.patchValue(this.group.value)
  //     });

  //   }
  //   else {
  //     const dialogRef = this.dialog.open(TextEditorComponent, {
  //       minWidth: '100vw', height: '100vh',
  //       data: { field: this.field, group: this.group }
  //     });

  //     dialogRef.afterClosed().subscribe(result => {
  //       this.group.patchValue(this.group.value)
  //     });
  //   }
  // }

  // openEditorDescription(formContronlName) {



  //   if (window.innerWidth > 768) {

  //     const dialogRef = this.dialog.open(TextEditorComponent, {
  //       width: '900px',
  //       disableClose: true,
  //       data: this.group.value[formContronlName]
  //     });

  //     dialogRef.afterClosed().subscribe(result => {
  //       if (result['event'] == 'add') {

  //         this.group.value[formContronlName] = result['data']
  //         this.group.patchValue(this.group.value)
  //       }


  //     });

  //   }
  //   else {
  //     const dialogRef = this.dialog.open(TextEditorComponent, {
  //       minWidth: '100vw', height: '100vh',
  //       disableClose: true,
  //       data: this.group.value[formContronlName]
  //     });

  //     dialogRef.afterClosed().subscribe(result => {
  //       if (result['event'] == 'add') {

  //         this.group.value[formContronlName] = result['data']
  //         this.group.patchValue(this.group.value)
  //       }

  //     });

  //   }
  // }


  openEditorDescription(formContronlName) {



    if (window.innerWidth > 768) {

      const dialogRef = this.dialog.open(TextEditorComponent, {
        width: '900px',
        disableClose: true,
        data: this.group.value[formContronlName]
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.group.value[formContronlName] = result['data']
          this.group.patchValue(this.group.value)
        }


      });

    }
    else {
      const dialogRef = this.dialog.open(TextEditorComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: this.group.value[formContronlName]
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.group.value[formContronlName] = result['data']
          this.group.patchValue(this.group.value)
        }

      });

    }
  }




  confirm(value, value1) {

    this.value
    this.visible = false;
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
